const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function csvRow(line) {
  const cells = [];
  let value = "";
  let quoted = false;
  for (let index = 0; index < line.length; index += 1) {
    const character = line[index];
    if (character === "\"") {
      if (quoted && line[index + 1] === "\"") {
        value += "\"";
        index += 1;
      } else {
        quoted = !quoted;
      }
    } else if (character === "," && !quoted) {
      cells.push(value.trim());
      value = "";
    } else {
      value += character;
    }
  }
  cells.push(value.trim());
  return cells;
}

export function parseRecipientText(value) {
  const recipients = [];
  const errors = [];
  const seen = new Set();
  String(value || "").split(/\r?\n/).forEach((line, index) => {
    if (!line.trim()) return;
    const cells = csvRow(line);
    const emailIndex = cells.findIndex(cell => EMAIL.test(cell.trim()));
    const email = emailIndex >= 0 ? cells[emailIndex].trim().toLowerCase() : "";
    const displayName = cells
      .filter((_cell, cellIndex) => cellIndex !== emailIndex)
      .join(" ")
      .trim()
      .slice(0, 255);
    if (!email) {
      errors.push(`Row ${index + 1}: enter a valid email address.`);
    } else if (seen.has(email)) {
      errors.push(`Row ${index + 1}: duplicate recipient ${email}.`);
    } else {
      seen.add(email);
      recipients.push({ email, displayName: displayName || null });
    }
  });
  return { recipients, errors };
}

export function parseRecipientCsv(value) {
  const lines = String(value || "").replace(/^\uFEFF/, "").split(/\r?\n/);
  const first = lines.findIndex(line => line.trim());
  if (first < 0) return { recipients: [], errors: ["The CSV file is empty."] };
  const header = csvRow(lines[first]).map(cell => cell.toLowerCase());
  const emailIndex = header.findIndex(cell => ["email", "email address", "recipient"].includes(cell));
  const nameIndex = header.findIndex(cell => ["name", "display name", "full name"].includes(cell));
  if (emailIndex < 0) {
    return { recipients: [], errors: ["The CSV header must contain an email column."] };
  }
  const text = lines.slice(first + 1)
    .filter(line => line.trim())
    .map(line => {
      const cells = csvRow(line);
      const email = cells[emailIndex] || "";
      const name = nameIndex >= 0 ? cells[nameIndex] || "" : "";
      return name ? `"${name.replace(/"/g, "\"\"")}",${email}` : email;
    })
    .join("\n");
  return parseRecipientText(text);
}
